import { apiRequest } from "./apiClient";

function notifyAuthChanged() {
  window.dispatchEvent(new Event("admin-auth-changed"));
}

export async function isAdminAuthenticated() {
  try {
    const data = await apiRequest("/auth/me");
    return Boolean(data?.authenticated);
  } catch (_error) {
    return false;
  }
}

export async function getAdminUsername() {
  try {
    const data = await apiRequest("/auth/me");
    return data?.username || null;
  } catch (_error) {
    return null;
  }
}

export async function signInAdmin(username, password) {
  const normalizedUsername = (username || "").trim();
  const normalizedPassword = (password || "").trim();

  if (!normalizedUsername || !normalizedPassword) {
    return {
      success: false,
      reason: "invalid",
      error: "Nom de compte ou mot de passe manquant.",
    };
  }

  try {
    const data = await apiRequest("/auth/login", {
      method: "POST",
      body: {
        username: normalizedUsername,
        password: normalizedPassword,
      },
    });

    notifyAuthChanged();

    return {
      success: true,
      username: data?.username || normalizedUsername,
    };
  } catch (error) {
    if (error?.status === 401 || error?.status === 400) {
      return {
        success: false,
        reason: "invalid",
        error: "Nom de compte ou mot de passe incorrect.",
      };
    }

    return {
      success: false,
      reason: "server",
      error: "Serveur indisponible. Réessayez dans un instant.",
    };
  }
}

export async function signOutAdmin() {
  try {
    await apiRequest("/auth/logout", {
      method: "POST",
    });
  } catch (_error) {
    // Even if API logout fails, we still notify the UI to refresh auth state.
  }

  notifyAuthChanged();
}
